module.exports = __webpack_public_path__ + "img/shopping-cart.155587e5.png";